
<main role="main" class="page-historique not-home-page">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="#">Accueil</a></li>
            <li class="breadcrumb-item"><a href="#">Grands chantiers</a></li>
            <li class="breadcrumb-item active">{{bloc.Titre}}</li>
          </ol>
        </nav>
        <!-- <h2>{{bloc.Titre}}</h2>
          <p class="text-primary size18 font-weight-semibold">
            {{bloc.Contenu}}
          </p> -->
          <div id="securiteportuaire">
          </div>                
      </div>
    </div>
  </div>
</main>